module.exports = __webpack_public_path__ + "media/images/pic/brodno/polygon_news_bigger-05e7c0bb35e0cbdbfb590b4608ac4074.svg";